import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ux-context-menu',
  templateUrl: './context-menu.component.html',
  styleUrls: ['./context-menu.component.less'],
  standalone: true,
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContextMenuComponent {
  view = 1;

  showMenu(event: any, menu: number): void {
    event.stopPropagation();
    this.view = menu;
  }
}
